import { ReactElement } from "react";

export type SplitPanelLightProps = {
    /** Určuje minimální hodnotu šířky kontejnerů v procentech. Celkový součet prvků nemůže být větší jak 100%. */
    readonly minSizePercentages: readonly number[];
    /** Určuje defaultní velikosti prvků split panelu v procentech. */
    readonly defaultPercentages?: readonly number[];
    readonly children: readonly ReactElement[];
    /* Určuje index prvku split panelu, který se má roztáhnout na maximální šířku/výšku kontejneru, ve kterém se nachází. */
    readonly fullDimensionIndex?: number | undefined;
};
